export default "__VITE_ASSET__Dcj5ZHrd__"